import { DateUtils } from '../utils/date.utils';
import { PortCallModel } from './port-call.model';
import { VesselModel } from './vessel.model';

export class VoyageModel {
  //Mode details objs
  public vesselDetails?: VesselModel;
  public portCalls: PortCallModel[] = [];

  constructor(
    public id?: any,
    public voyageNumber?: string,
    public vessel?: string,
    public status?: string,
    public plannedDepartureDate?: string,
    public createdAt?: string,
    public vlsfoUsdPerMetricTon?: number,
    public mgoUsdPerMetricTon?: number,
    public revenue?: number,
  ) { }

  public fromJSON(json: any): VoyageModel {
    if (json) {
      this.id = json.id;
      this.voyageNumber = json.voyageNumber;
      this.status = json.status;
      this.plannedDepartureDate = DateUtils.cleanApiDate(
        json.plannedDepartureDate
      );
      this.createdAt = DateUtils.cleanApiDate(json.createdAt);
      this.vlsfoUsdPerMetricTon = json.vlsfoUsdPerMetricTon;
      this.mgoUsdPerMetricTon = json.mgoUsdPerMetricTon;
      this.revenue = json.revenue;
      this.portCalls = [];

      //Check vessel
      if (typeof json.vessel === 'object') {
        this.vesselDetails = new VesselModel().fromJSON(json.vessel);
        this.vessel = this.vesselDetails.id?.toString();
      } else {
        this.vesselDetails = undefined;
        this.vessel = json.vessel;
      }

      //Check port calls
      if (Array.isArray(json.portCalls)) {
        this.portCalls = json.portCalls.map((portCall: any) =>
          new PortCallModel().fromJSON(portCall)
        );
      }
    }
    return this;
  }

  public fromJSONList(json: any): VoyageModel[] {
    if (json) {
      return json.map((element: any) => new VoyageModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      voyageNumber: this.voyageNumber,
      vessel: this.vessel,
      status: this.status,
      plannedDepartureDate: this.plannedDepartureDate,
      vlsfoUsdPerMetricTon: this.vlsfoUsdPerMetricTon,
      mgoUsdPerMetricTon: this.mgoUsdPerMetricTon,
      revenue: this.revenue,
      createdAt: this.createdAt,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.voyageNumber ?? '';
  }
}
